// Columnas visibles de la Carga Académica. Se guardan las ocultas (no las visibles) para que
// una División de tiempo nueva aparezca visible, y se recuerdan en localStorage por
// usuario e institución. Nombre no se puede ocultar: identifica la fila.
import { computed, ref, watch } from "vue";

export const SUBJECT_COLUMNS = [
  "period",
  "internal_code",
  "code",
  "prerequisites",
  "pucv_credits",
  "sct_credits",
];
// Cada total ocupa dos columnas (semanal y semestral)
export const TOTAL_COLUMNS = ["presential", "autonomous", "dedication"];
// Apartados que se repiten por División de tiempo
export const ALLOCATION_GROUPS = [
  "hours",
  "quota",
  "classroom_type",
  "periodicity",
];
export const NOTE_COLUMNS = [
  "quota_justification",
  "academic_load_observation",
];

export function allocationColumnKey(group, time_allocation) {
  return `${group}:${time_allocation.id}`;
}

function readHidden(storage_key) {
  if (!storage_key) return [];
  try {
    const value = JSON.parse(localStorage.getItem(storage_key));
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

function writeHidden(storage_key, hidden) {
  if (!storage_key) return;
  try {
    if (hidden.length > 0)
      localStorage.setItem(storage_key, JSON.stringify(hidden));
    else localStorage.removeItem(storage_key);
  } catch {
    // Sin localStorage (modo privado, bloqueado) la selección dura solo la visita
  }
}

// time_allocations y storage_key son refs/computeds; storage_key puede llegar tarde
// (usuario o institución aún sin cargar).
export default function useAcademicLoadColumns(time_allocations, storage_key) {
  const hidden = ref([]);
  watch(
    storage_key,
    (key) => {
      hidden.value = readHidden(key);
    },
    { immediate: true }
  );

  function isVisible(key) {
    return !hidden.value.includes(key);
  }

  function setVisible(keys, visible) {
    const others = hidden.value.filter((key) => !keys.includes(key));
    hidden.value = visible ? others : [...others, ...keys];
    writeHidden(storage_key.value, hidden.value);
  }

  function showAll() {
    setVisible(hidden.value, true);
  }

  function visibleAllocations(group) {
    return time_allocations.value.filter((time_allocation) =>
      isVisible(allocationColumnKey(group, time_allocation))
    );
  }

  // { period: Boolean, ..., hours: [TimeAllocation], quota: [...], ... }
  const visibleColumns = computed(() => {
    const columns = {};
    [...SUBJECT_COLUMNS, ...TOTAL_COLUMNS, ...NOTE_COLUMNS].forEach((key) => {
      columns[key] = isVisible(key);
    });
    ALLOCATION_GROUPS.forEach((group) => {
      columns[group] = visibleAllocations(group);
    });
    return columns;
  });

  // Solo cuenta columnas existentes: claves de Divisiones de tiempo eliminadas no suman
  const hiddenCount = computed(() => {
    const allocation_keys = time_allocations.value.flatMap((time_allocation) =>
      ALLOCATION_GROUPS.map((group) =>
        allocationColumnKey(group, time_allocation)
      )
    );
    const keys = [
      ...SUBJECT_COLUMNS,
      ...TOTAL_COLUMNS,
      ...NOTE_COLUMNS,
      ...allocation_keys,
    ];
    return hidden.value.filter((key) => keys.includes(key)).length;
  });

  return { isVisible, setVisible, showAll, visibleColumns, hiddenCount };
}
